import React from "react";
import { Invoice } from "@/interface/entityInterface";
import { Sheet } from "@/interface/dataInterface";
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import CommonDetailsDialog from "@/components/common/details/DetailsDialog";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";
import { Button } from "@/components/ui/button";
import { generateInvoiceDoc } from "@/utils/download";
import { RowPinning } from "@tanstack/react-table";

interface invoiceDetailsSheetProps extends Sheet {
  invoice: Invoice | null;
}

const InvoiceDetails: React.FC<invoiceDetailsSheetProps> = ({
  invoice,
  open,
  setOpen,
}) => {
  if (!invoice) return null;

  return (
    <CommonDetailsDialog
      open={open}
      setOpen={setOpen}
      title="invoice details"
      description={`Total breakdown of invoice # ${invoice.id}`}
    >
      <div className="w-full max-w-2xl mx-auto bg-background shadow-md overflow-hidden sm:rounded-lg">
        <div className="px-6 py-4 space-y-6">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-gray-500">Billed to: {invoice.guest_user.name}</p>
              <p className="text-gray-500">Payment method: {invoice.payment}</p>
            </div>
            <div>
              <p className="text-gray-500">{format(invoice.date, "dd MMMM yyyy HH:mm")}</p>
            </div>
          </div>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Quantity</TableHead>
                <TableHead>Price</TableHead>
                <TableHead>Total</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {invoice.invoice_items.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>
                    {item.title}
                  </TableCell>
                  <TableCell>
                    {item.quantity} {item.unit}
                  </TableCell>
                  <TableCell>${item.price}</TableCell>
                  <TableCell>${item.price * item.quantity}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell>Total</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell className="font-bold">
                  ${invoice.total}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <div>{invoice.notes}</div>
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={() => generateInvoiceDoc(invoice)}>Download</Button>
      </div>
    </CommonDetailsDialog>
  );
};

export default InvoiceDetails;
